import React, { useState } from "react";
import { Form, Col } from "react-bootstrap";
import { DatePicker2 } from "./DatePicker";
import { AutoComplete } from "./AutoComplete";
import { _t, i18n } from "../../../app/i18n/i18n";
import { getParam } from "pages/search/api/filterUrlMaker";
import { _c, getTagsFromURL } from "./util";
import autoCompleteOptions from "./autoCompleteConfig.json";

export const ReportFilters = () => {
  const [showDatePicker, setShowDatePicker] = useState((getParam(_c("Date")) || []).includes("Range"));
  const getStartDate = () =>
    (getParam(_c("Date")) || []).includes("Range") ? new Date(+getParam(_c("Date")).split("|")[1]) : new Date();
  const getEndDate = () =>
    (getParam(_c("Date")) || []).includes("Range") ? new Date(+getParam(_c("Date")).split("|")[2]) : new Date();

  const [startDate, setStartDate] = useState(getStartDate());
  const [endDate, setEndDate] = useState(getEndDate());

  const getCustomDateRange = () => {
    return "Range|" + startDate.getTime() + "|" + endDate.getTime();
  };
  return (
    <section>
      <Form.Group as={Form.Row} controlId="language" className="mb-1">
        <Form.Label column sm="2" className="pb-0">
          {_t("Language")}
        </Form.Label>
        <Col sm="5">
          <Form.Check
            type="checkbox"
            label={_t("English")}
            name="language"
            id="english"
            inline
            defaultChecked={!getParam(_c("Language")) || getParam(_c("Language")).includes("en")}
            datainputtype="check"
            datafield="Language"
            datavalue="en"
          />
          <Form.Check
            type="checkbox"
            label={_t("Japanese")}
            name="language"
            id="japanese"
            inline
            defaultChecked={!getParam(_c("Language")) || getParam(_c("Language")).includes("ja")}
            datainputtype="check"
            datafield="Language"
            datavalue="ja"
          />
        </Col>
      </Form.Group>

      <Form.Group as={Form.Row} controlId="assetclass" className="mb-1">
        <Form.Label column sm="2" className="pb-0">
          {_t("Asset Class")}
        </Form.Label>
        <Col sm="5">
          <Form.Check
            type="checkbox"
            label={_t("Equity")}
            name="assetclass"
            id="Equity"
            defaultChecked={!getParam(_c("Asset Class")) || getParam(_c("Asset Class")).includes("Equity")}
            inline
            datainputtype="check"
            datafield="Asset Class"
            datavalue={_t("Equity")}
          />
          <Form.Check
            type="checkbox"
            label={_t("Fixed Income")}
            name="assetclass"
            id="Fixed Income"
            defaultChecked={!getParam(_c("Asset Class")) || getParam(_c("Asset Class")).includes("Fixed Income")}
            inline
            datainputtype="check"
            datafield="Asset Class"
            datavalue={_t("Fixed Income")}
          />
          <Form.Check
            type="checkbox"
            label={_t("Economics")}
            name="assetclass"
            id="Economics"
            defaultChecked={!getParam(_c("Asset Class")) || getParam(_c("Asset Class")).includes("Economics")}
            inline
            datainputtype="check"
            datafield="Asset Class"
            datavalue={_t("Economics")}
          />
          <Form.Check
            type="checkbox"
            label={_t("FX")}
            name="assetclass"
            id="FX"
            defaultChecked={!getParam(_c("Asset Class")) || getParam(_c("Asset Class")).includes("FX")}
            inline
            datainputtype="check"
            datafield="Asset Class"
            datavalue={_t("FX")}
          />
        </Col>
      </Form.Group>

      <Form.Group as={Form.Row} controlId="publicationdate" className="mb-1">
        <Form.Label column sm="2" className="pb-0">
          {_t("Publication Date")}
        </Form.Label>
        <Col sm="5">
          <Form.Check
            type="radio"
            label={_t("This week")}
            name="publicationdate"
            id="week"
            inline
            defaultChecked={(getParam(_c("Date")) || []).includes("1 Week")}
            datainputtype="radio"
            datafield="Date"
            datavalue="1 Week"
          />
          <Form.Check
            type="radio"
            label={_t("Last month")}
            name="publicationdate"
            id="month"
            inline
            defaultChecked={(getParam(_c("Date")) || []).includes("1 Month")}
            datainputtype="radio"
            datafield="Date"
            datavalue="1 Month"
          />
          <Form.Check
            type="radio"
            label={_t("6 Months")}
            name="publicationdate"
            id="six_months"
            inline
            defaultChecked={(getParam(_c("Date")) || []).includes("6 Months")}
            datainputtype="radio"
            datafield="Date"
            datavalue="6 Months"
          />
          <Form.Check
            type="radio"
            label={_t("Last year")}
            name="publicationdate"
            id="year"
            inline
            defaultChecked={(getParam(_c("Date")) || []).includes("1 Year")}
            datainputtype="radio"
            datafield="Date"
            datavalue="1 Year"
          />
          <Form.Check
            type="radio"
            label={_t("All time")}
            name="publicationdate"
            id="alltime"
            inline
            defaultChecked={!getParam(_c("Date"))}
            datainputtype="radio"
            datafield="Date"
            datavalue=""
          />
          <Form.Check
            type="radio"
            label={_t("Custom range")}
            name="publicationdate"
            id="custom"
            defaultChecked={(getParam(_c("Date")) || []).includes("Range")}
            inline
            onClick={() => setShowDatePicker(true)}
            datainputtype="radio"
            datafield="Date"
            datavalue={getCustomDateRange()}
          />
        </Col>
      </Form.Group>

      <Form.Row className={!showDatePicker ? "d-none" : "mb-2"}>
        <Col sm="2"></Col>
        <Col sm="3">
          <span>
            <Form.Text className="mt-0">{_t("From date")}</Form.Text>
            <DatePicker2 date={startDate} handleDateChange={setStartDate} max={endDate} />
          </span>
        </Col>
        <Col sm="3">
          <Form.Text className="mt-0">{_t("To date")}</Form.Text>
          <DatePicker2 date={endDate} handleDateChange={setEndDate} min={startDate} />
        </Col>
      </Form.Row>

      {/* TODO update report types from MS' email */}
      <Form.Group as={Form.Row} controlId="reporttype" className="mb-1">
        <Form.Label column sm="2" className="pb-0">
          {_t("Report Type")}
        </Form.Label>
        <Col sm="5">
          <AutoComplete
            initialTags={getTagsFromURL(_c("Report Types"), autoCompleteOptions["ReportTypes_" + i18n.getLanguage()])}
            name="reporttype"
            datafield="Report Types"
            options={autoCompleteOptions["ReportTypes_" + i18n.getLanguage()]}
          />
        </Col>
      </Form.Group>
    </section>
  );
};
